/**
 * tvManuscriptModule 广电广电文稿-编辑页
 * description:  广电广电文稿-编辑页
 * author: Qian.qianchen 2019-04-03
 */
'use strict';
angular.module('broadcastManuscriptModule', [])
    .controller('broadcastManuscriptCtrl', ['$scope', 'localStorageService', 'trsHttpService', 'editIsLock', 'modalDialog', '$timeout', '$validation', 'storageListenerService', '$state', '$stateParams', '$element', 'editingCenterService', 'ueditorService', '$modal', '$q', '$window', '$compile', 'jsonArrayToStringService', 'beforeonload', 'trsspliceString', 'initeditctrBtnsService',
        function($scope, localStorageService, trsHttpService, editIsLock, modalDialog, $timeout, $validation, storageListenerService, $state, $stateParams, $element, editingCenterService, ueditorService, $modal, $q, $window, $compile, jsonArrayToStringService, beforeonload, trsspliceString, initeditctrBtnsService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    switch: 'manuscriptInfo', // 默认选中稿件信息
                    manuscriptFormError: [],
                    isHaveExtend: false, // 是否含有扩展信息
                    articleSelectorShow: false,
                    leadSelectorShow: false,
                    compileSelectorShow: false,
                    totalSelectorShow: false,
                    zhengwen: false,
                    isFusionEditor: false,
                    saveDocRouter: ['saveWenGaoDocForDaiBianEdit', 'saveWenGaoDocForDaiShenEdit', 'saveWenGaoDocForYiQianEdit'],
                    directSignRouter: ['broadcastDaiBianPublish', 'broadcastDaiShenPublish'],
                    platform: $stateParams.broadcastplatform,
                    support: {},
                    btnRights: {},
                    broadcastMetadataId: $stateParams.broadcastmetadataid
                };
                $scope.data = {
                    userName: '',
                    articleDuration: '00:00:00', // 正文时长
                    leadDuration: '00:00:00', // 导语时长
                    compileDuration: '00:00:00', // 编后时长
                    totalDuration: '00:00:00', // 总时长
                    reporterArr: [],
                    compileArr: [],
                    broadcastArr: [],
                    copyVersion: []

                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20
                };
                emitCloseWindow();
                initBtnRights();
                $scope.editFlag = {
                    media: 'broadcast', 
                    docType: 'manuscript',
                };
            }

            /**
             * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
             * @return {[type]} [description]
             */
            function emitCloseWindow() {
                // window.onbeforeunload = function() {
                //     localStorageService.set("unLocakDraft", JSON.stringify({ metadataid: $stateParams.broadcastmetadataid }));
                // };
                editingCenterService.allAppCloseWindow($scope, {typeName: 'broadcast', saveLocal: false});
            }

            /**
             * [initBtnRights description] 初始化按钮权限
             * @return {[type]} [description]
             */
            function initBtnRights() {
                let rightsMethod = ['broadcast.daibian', 'broadcast.daishen', 'broadcast.yiqianfa'];
                initeditctrBtnsService.initTvData($stateParams.broadcastchannelid, rightsMethod[$stateParams.broadcastplatform]).then((data) => {
                    data.forEach((item, index) => {
                        $scope.status.btnRights[item.OPERNAME.split('.')[2]] = true;
                    });
                });

                /* initeditctrBtnsService.initIwoData(methodnameArray[$stateParams.iwoplatform]).then(function(data) {
                    data.forEach((item, index) => {
                        $scope.status.btnRights[item.OPERNAME.split(".")[2]] = true;
                    });
                });*/
            }

            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                initEditData().then(function() {
                    // storageListenerService.removeListener("television");
                    beforeonload.beforeonloadAlert($scope);
                });
            }

            /**
             * [initEditData description] 获取编辑的稿件信息
             * @return {[type]} [description]
             */
            function initEditData() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: 'getWenGaoDoc',
                    MetaDataId: $stateParams.broadcastmetadataid
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    data.EXATTRIBUTE = data.EXATTRIBUTE instanceof Array ? data.EXATTRIBUTE : [];
                    $scope.list = data;
                    document.title = data.TITLE;
                    $scope.data.reporterArr = data.FGD_AUTHINFO;
                    $scope.data.compileArr = data.FGD_EDITINFO;
                    $scope.data.speed = data.SPEECHRATE.split('字/分钟')[0];
                    $scope.data.selectedColumn = {
                        name: data.QUOTECHNLDESC,
                        value: data.QUOTECHNLID || data.CHANNELID,
                    };
                    if (data.EXATTRIBUTE.length > 0) {
                        $scope.status.isHaveExtend = true;
                        $scope.list.EXATTRIBUTE.map(function(item) {
                            item.enumArr = item.formType == 'input' ? '' : item.enumValue.split(',').map(function(item) {
                                return { 'name': item };
                            });
                            item.value = item.formType == 'input' ? item.value : { 'name': item.value };
                        });
                    } else {
                        $scope.status.isHaveExtend = false;
                    }
                    $scope.data.broadcastArr = data.BROADCASTING;
                    $scope.data.EXATTRIBUTE = angular.copy($scope.list.EXATTRIBUTE);
                    getVersion().then(function() {
                        return loadDirective();
                    }).then(function() {
                        return getAllChannels();
                    }).then(function() {
                        defer.resolve();
                    });
                    editIsLock.lockDraft($stateParams.broadcastmetadataid);
                });
                return defer.promise;
            }

            /**
             * [getAllChannels description] 获取所有栏目
             * @return {[type]} [description]
             */
            function getAllChannels() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: 'getAllChannelsOfDaibian',
                    webSiteId: $stateParams.broadcastsiteid
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.columns = [];
                    if (Object.prototype.toString.call(data) == '[object Array]') {
                        var items = [];
                        angular.forEach(data, function(obj, index) {
                            items.push({
                                name: obj.CHNLDESC,
                                value: obj.CHANNELID
                            });
                        });
                        $scope.data.columns = $scope.data.columns.concat(items);
                    }
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [loadDirective description] 动态加载编辑器指令
             * @return {[type]} [description]
             */
            function loadDirective() {
                var defer = $q.defer();
                if ($stateParams.issave === undefined || $stateParams.issave === '0') { // 用于融合编辑器的虚拟表单校验，虚拟表单检验不需要加载编辑器
                    LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function() {

                        var ueditor = '<ueditor-for-manuscript form="manuscriptForm" has-content="status.hasContent" versionid = "data.lastVersionid" list="list" infullscreen="status.infullscreen" speed="' + $scope.data.speed + '"></ueditor-for-manuscript>';
                        // $scope.button = { title: "政治常识校对", name: "polComSense" };
                        // var ueditor = '<ueditor custom-button-fn="politicalCommonSense()" custom-button="button" form="manuscriptForm" versionid = "data.lastVersionid" list="list"></ueditor>';
                        ueditor = $compile(ueditor)($scope);
                        $element.find('ueditorLocation').append(ueditor);
                        $scope.status.support.content = $scope.list.CONTENT;
                        var ue = UE.getEditor('ueditor');
                        ue.ready(function() {
                            ue.addListener('keydown', function(type, event) {
                                if (event.keyCode === 13) {
                                    // 获取纯文本
                                    $scope.status.support.content = ue.getContentTxt();
                                }
                            });
                            defer.resolve();
                        });
                    });
                } else {
                    defer.resolve();
                }
                return defer.promise;
            }

            /**
             * [getVersion description]获取流程版本与操作日志
             * @return {[type]} [description]
             */
            function getVersion(id) {
                var deferred = $q.defer();
                var metadataid = angular.isDefined(id) ? id : $stateParams.broadcastmetadataid;
                editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(function(data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deferred.resolve();
                }, function() {
                    deffered.resolve();
                });
                return deferred.promise;
            }

            /**
             * [saveContent description] 保存内容
             * @return {[type]} [description]
             */
            function saveContent() {
                if (!$scope.status.isFusionEditor) {
                    ueditorService.saveContent($scope.list);
                }
            }

            /**
             * [getText description] 全文本数据拼接
             * @param  {[type]} content  [description] 全文内容
             * @param  {[type]} strStart [description] 文本开始标识符
             * @return {[type]}          [description] 匹配的内容
             */
            function getText(content, strStart) {
                var indexArr = getAllIndex(content, strStart);
                var matchContent = '';
                for (var i = 0; i < indexArr.length; i++) {
                    var leadNextIndex = content.indexOf('【导语】', indexArr[i] + 4);
                    var mainNextIndex = content.indexOf('【正文】', indexArr[i] + 4);
                    var compileNextIndex = content.indexOf('【编后】', indexArr[i] + 4);
                    var nearNextIndex = getMin([leadNextIndex, mainNextIndex, compileNextIndex], -1);
                    if (nearNextIndex != false) {
                        matchContent += content.substring(indexArr[i] + 4, nearNextIndex);
                    } else {
                        matchContent += content.substring(indexArr[i] + 4);
                    }
                }
                return matchContent.replace(/\\n/g, '').replace(/\s+/g, '');
            }

            /**
             * [timeTransform description] 时间格式转化
             * @param  {[type]} time [description] 时间（秒）
             * @return {[type]}      [description]
             */
            function timeTransform(time) {
                var hours = Math.floor(time / (60 * 60)) < 10 ? '0' + Math.floor(time / (60 * 60)) : Math.floor(time / (60 * 60));
                var minutes = Math.floor((time - hours * 60 * 60) / 60) < 10 ? '0' + Math.floor((time - hours * 60 * 60) / 60) : Math.floor((time - hours * 60 * 60) / 60);
                var seconds = Math.round(time - hours * 60 * 60 - minutes * 60) < 10 ? '0' + Math.round(time - hours * 60 * 60 - minutes * 60) : Math.round(time - hours * 60 * 60 - minutes * 60);
                return hours + ':' + minutes + ':' + seconds;
            }

            /**
             * [getAllIndex description] 获取指定字符串的全部下标
             * @param  {[type]} str    [description] 内容
             * @param  {[type]} subStr [description] 指定的字符串
             * @return {[type]}        [description] 下标数组
             */
            function getAllIndex(str, subStr) {
                var positions = new Array();
                var pos = str.indexOf(subStr);
                while (pos > -1) {
                    // 每次搜索返回的位置被保存在数组positions中
                    positions.push(pos);
                    // 给indexOf()传递上一次的位置加1，确保了每次新搜索都从上一次找到的子字符串的后面开始
                    pos = str.indexOf(subStr, pos + 1);
                }
                return positions;
            }

            /**
             * [getMin description] 获取数组最小值
             * @param  {[type]} arr      [description] 数组
             * @param  {[type]} minFloor [description] 最小值下限
             * @return {[type]}          [description]
             */
            function getMin(arr, minFloor) {
                var dealedArr = [];
                arr.forEach(function(item, index) {
                    if (item > minFloor) {
                        dealedArr.push(item);
                    }
                });
                if (dealedArr.length == 0) {
                    return false;
                } else {
                    var min = dealedArr[0];
                    dealedArr.forEach(function(item) {
                        if (item < min) {
                            min = item;
                        }
                    });
                    return min;
                }
            }

            /**
             * [getObjFromArr description] 根据属性查询数组中的对象
             * @param  {[type]} arr      [description] 数组
             * @param  {[type]} property [description] 属性名
             * @param  {[type]} value    [description] 属性只
             * @return {[type]}          [description]
             */
            function getObjFromArr(arr, property, value) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i][property] == value) {
                        return arr[i];
                    }
                }
                return -1;
            }

            /**
             * [listDataFormat description] 稿件信息格式化
             * @return {[type]} [description]
             */
            function listDataFormat() {
                $scope.list.CONTENTSTRUCTURE = identificationFormat($scope.list.CONTENT);
                $scope.list.BROADCASTING = $scope.data.broadcastArr.map(function(item) {
                    return item.ID;
                }).join(',');
                $scope.list.BROADCASTINGNAME = trsspliceString.spliceString($scope.data.broadcastArr, 'USERNAME', ',');
                $scope.list.FGD_EDITINFO = $scope.data.compileArr;
                $scope.list.FGD_AUTHINFO = $scope.data.reporterArr;
            }

            /**
             * [identificationFormat description] 标识符格式化
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            function identificationFormat(content) {
                if (content.match(/【(.*?)】/g) == null) {
                    return '';
                } else {
                    var identificationArr = content.match(/【(.*?)】/g).map(function(item) {
                        return item.substring(1, item.length - 1);
                    });
                    var structureArr = [];
                    for (var i = 0; i < identificationArr.length; i++) {
                        if (identificationArr[i] == '导语') {
                            structureArr.push('导');
                        } else if (identificationArr[i] == '正文') {
                            structureArr.push('正');
                        } else if (identificationArr[i] == '编后') {
                            structureArr.push('编');
                        }
                    }
                    return structureArr.join(',');
                }
            }

            /**
             * [disposeAttribute 格式化属性字段]
             * @return {[type]} [description]
             */
            function disposeAttribute() {
                $scope.list.EXATTRIBUTE = angular.copy($scope.data.EXATTRIBUTE);
                for (var i = 0; i < $scope.list.EXATTRIBUTE.length; i++) {
                    var obj = $scope.list.EXATTRIBUTE[i];
                    if (obj.formType == 'select') {
                        obj.enumValue = trsspliceString.spliceString(obj.enumArr, 'name', ',');
                        obj.value = obj.value ? obj.value.name : '';
                    }
                    delete obj.enumArr;
                }
            }

            /**
             * [saveBroadcastDoc description] 电视广电文稿保存
             * @return {[type]} [description]
             */
            function saveBroadcastDoc() {
                var defer = $q.defer();
                disposeAttribute();
                var list = angular.copy($scope.list);
                list.serviceid = 'mlf_broadcast';
                list.METHODNAME = $scope.status.saveDocRouter[$stateParams.broadcastplatform];
                list.QuoteChnlId = $scope.data.selectedColumn.value;
                list.SITEID = $stateParams.broadcastsiteid;
                delete list.CHNLDESC;
                delete list.CHNLNAME;
                list = jsonArrayToStringService.jsonArrayToString(list);
                list.HTMLCONTENT = list.HTMLCONTENT.replace(/_ueditor_page_break_tag_/g, "<hr class='pagebreak' noshade='noshade' size='5' style='-webkit-user-select: none;'>");
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', list, 'post').then(function(result) {
                    $scope.list.METADATAID = result.METADATAID;
                    $scope.list.CHNLDOCID = result.CHNLDOCID;
                    defer.resolve(result);
                });
                return defer.promise;
            }

            /**
             * [save description] 保存
             * @param  {[type]} flag [description] 标识符
             * @return {[type]}      [description]
             */
            function save(flag) {
                var defer = $q.defer();
                saveContent();
                $timeout(function() {
                    $scope.manuscriptForm.$pending = {};
                    $validation.validate($scope.manuscriptForm)
                        .success(function() {
                            modalDialog.isSecretInformation($stateParams.broadcastmetadataid, function() {
                                // sensitiveWordCheckService.sensitiveWords($scope).then(function(sensitiveWords) {
                                // $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                $scope.manuscriptForm.$setPristine();
                                listDataFormat();
                                saveBroadcastDoc().then(function(data) {
                                    if (flag) {
                                        storageListenerService.addListenerToBroadcast('save');
                                        $stateParams.broadcastchannelid = data.CHANNELID;
                                        $state.transitionTo($state.current, $stateParams, {
                                            reload: false
                                        });
                                        $timeout(function() {
                                            modalDialog.saveModel('保存成功', '', 'success');
                                        }, 500);
                                    }
                                    beforeonload.refresh($scope);
                                    defer.resolve();
                                });
                                // });
                            }, function() {
                                defer.reject();
                            }, $scope.status.isFusionEditor);
                        }).error(function(msg) {
                            angular.invalidPosition($scope.manuscriptForm, $element);
                            defer.reject();
                        });
                });
                return defer.promise;
            }

            /**
             * [trial description] 送审
             * @return {[type]} [description]
             */
            function trial() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: 'trialMetaDatas',
                    ChnlDocIds: $scope.list.CHNLDOCID,
                    CurrChnlId: $scope.data.selectedColumn.value,
                    MetaDataIds: $scope.list.METADATAID
                };
                modalDialog.inputModel('送审', '确定送审吗？', function(content) {
                    params.Opinion = content;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', false).then(function(dataC) {
                        modalDialog.alertType('送审成功', '', 'success', false,
                            function() {
                                storageListenerService.addListenerToBroadcast('send');
                                $window.close();
                            }, '', 1500);
                    }, function() {
                        editIsLock.lockDraft($stateParams.broadcastmetadataid);
                    });
                }, '', function() {
                    editIsLock.lockDraft($stateParams.broadcastmetadataid);
                });
            }

            /**
             * [directSign description] 直接签发
             * @return {[type]} [description]
             */
            function directSign() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: $scope.status.directSignRouter[$scope.status.platform],
                    ChnlDocIds: $scope.list.CHNLDOCID,
                };
                modalDialog.confirmModal('签发', '确定直接签发吗？', function() {
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', false).then(function(dataC) {
                        modalDialog.alertType('签发成功', '', 'success', false,
                            function() {
                                storageListenerService.addListenerToBroadcast('sign');
                                $window.close();
                            }, '', 1500);
                    }, function() {
                        editIsLock.lockDraft($stateParams.broadcastmetadataid);
                    });
                }, function() {
                    editIsLock.lockDraft($stateParams.broadcastmetadataid);
                });
            }

            /**
             * [withdraw description] 退回
             * @return {[type]} [description]
             */
            function withdraw() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: 'rejectionMetaDatas',
                    ChnlDocIds: $scope.list.CHNLDOCID,
                    ChannelId: $scope.data.selectedColumn.value,
                };
                modalDialog.inputModel('退回', '确定退回吗？', function(content) {
                    params.Opinion = content;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', false).then(function(dataC) {
                        modalDialog.alertType('退回成功', '', 'success', false,
                            function() {
                                storageListenerService.addListenerToBroadcast('withdraw');
                                $window.close();
                            }, '', 1500);
                    }, function() {
                        editIsLock.lockDraft($stateParams.broadcastmetadataid);
                    });
                }, '', function() {
                    editIsLock.lockDraft($stateParams.broadcastmetadataid);
                });
            }

            /**
             * [retreat description] 退稿
             * @return {[type]} [description]
             */
            function retreat() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: 'retreat',
                    MetaDataIds: $scope.list.METADATAID,
                };
                modalDialog.inputModel('退稿', '确定退稿吗？', function(content) {
                    params.Opinion = content;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', false).then(function(dataC) {
                        modalDialog.alertType('退稿成功', '', 'success', false,
                            function() {
                                storageListenerService.addListenerToBroadcast('withdraw');
                                $window.close();
                            }, '', 1500);
                    }, function() {
                        editIsLock.lockDraft($stateParams.broadcastmetadataid);
                    });
                }, '', function() {
                    editIsLock.lockDraft($stateParams.broadcastmetadataid);
                });
            }

            /**
             * [publish description] 保存并发布
             * @return {[type]} [description]
             */
            function publish() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: 'broadcastYiQianPublish',
                    ChnlDocIds: $scope.list.CHNLDOCID,
                };
                modalDialog.confirmModal('签发', '确定直接签发吗？', function() {
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', false).then(function(dataC) {
                        modalDialog.alertType('签发成功', '', 'success', false,
                            function() {
                                storageListenerService.addListenerToBroadcast('sign');
                                $window.close();
                            }, '', 1500);
                    }, function() {
                        editIsLock.lockDraft($stateParams.broadcastmetadataid);
                    });
                }, function() {
                    editIsLock.lockDraft($stateParams.broadcastmetadataid);
                });
            }

            /**
             * [theFormError description] 获取表单变化
             * @return {[type]} [description]
             */
            $scope.theFormError = function() { // 当表单发生变化时会进入方法
                var errorArray = [];
                for (var error in $scope.manuscriptForm.$error) {
                    errorArray.push(error);
                }
                $scope.status.manuscriptFormError = $scope.status.manuscriptFormError == undefined ? [] : $scope.status.manuscriptFormError;
                if ($scope.status.manuscriptFormError.length != errorArray.length) { // 长度不相等说明表单errorname发生变化
                    $scope.status.manuscriptFormError = errorArray;
                }
                return $scope.status.manuscriptFormError; // 返回
            };

            /**
             * [initialSelector description] 时间选择器初始化
             * @return {[type]} [description]
             */
            $scope.initialSelector = function() {
                $scope.status.articleSelectorShow = false;
                $scope.status.leadSelectorShow = false;
                $scope.status.compileSelectorShow = false;
                $scope.status.totalSelectorShow = false;
            };

            /**
             * [calculateAuto description] 时间自动计算
             * @return {[type]} [description]
             */
            $scope.calculateAuto = function() {
                var ue = UE.getEditor('ueditor');
                var content = ueditorService.getTextContent(ue.getContent());
                var leadContent = getText(content, '【导语】');
                var mainContent = getText(content, '【正文】');
                var compileContent = getText(content, '【编后】');
                var leadSeconds = leadContent.length * 60 > 0 ? leadContent.length * 60 / $scope.data.speed : 0;
                var mainSeconds = mainContent.length * 60 > 0 ? mainContent.length * 60 / $scope.data.speed : 0;
                var compileSeconds = compileContent.length * 60 > 0 ? compileContent.length * 60 / $scope.data.speed : 0;
                $scope.list.CONTENTDURATION = timeTransform(mainSeconds);
                $scope.list.INTRODUCERDURATION = timeTransform(leadSeconds);
                $scope.list.EDITINGDURATION = timeTransform(compileSeconds);
                $scope.list.TOTALDURATION = timeTransform(mainSeconds + leadSeconds + compileSeconds);
            };

            /**
             * [toggleEditor description] 展开/收起全文
             * @return {[type]} [description]
             */
            $scope.toggleEditor = function() {
                $scope.status.zhengwen = !$scope.status.zhengwen;
                if ($scope.status.zhengwen) { // 隐藏编辑器
                    $('.body_manuscript_content').addClass('editorHidden');
                } else {
                    $('.body_manuscript_content').removeClass('editorHidden');
                }

            };
            $scope.$watch('data.currReporter', function(newValue, oldValue, scope) {
                if (angular.isObject(newValue)) {
                    if (getObjFromArr($scope.data.reporterArr, 'ID', newValue.ID) == -1) {
                        newValue.TYPE = '23';
                        $scope.data.reporterArr.push(newValue);
                    }
                    $scope.data.currReporter = '';
                }
            });
            $scope.$watch('data.currBroadcast', function(newValue, oldValue, scope) {
                if (angular.isObject(newValue)) {
                    if (getObjFromArr($scope.data.broadcastArr, 'ID', newValue.ID) == -1) {
                        $scope.data.broadcastArr.push(newValue);
                    }
                    $scope.data.currBroadcast = '';
                }
            });
            $scope.$watch('data.currEditor', function(newValue, oldValue, scope) {
                if (angular.isObject(newValue)) {
                    if (getObjFromArr($scope.data.compileArr, 'ID', newValue.ID) == -1) {
                        newValue.TYPE = '21';
                        $scope.data.compileArr.push(newValue);
                    }
                    $scope.data.currEditor = '';
                }
            });

            /**
             * [deleteItem description] 数组删除元素
             * @param  {[type]} arr  [description] 数组
             * @param  {[type]} item [description] 元素
             * @return {[type]}      [description]
             */
            $scope.deleteItem = function(arr, item) {
                arr.splice(arr.indexOf(item), 1);
            };

            /**
             * [addUser description] 添加用户
             * @param {[type]} arrProperty [description] 用户数组名
             */
            $scope.addUser = function(arrProperty) {
                $scope.editorJson = $scope.data[arrProperty];
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/directive/app/views/editor_window_other_tpl.html',
                    scope: $scope,
                    windowClass: 'editor_window_class',
                    backdrop: false,
                    controller: 'editorOtherCtrl',
                });
                modalInstance.result.then(function(result) {
                    for (var i = 0; i < result.length; i++) {
                        if (getObjFromArr($scope.data[arrProperty], 'ID', result[i].ID) == -1) {
                            result[i].TYPE = arrProperty === 'reporterArr' ? '23' : arrProperty === 'compileArr' ? '21' : '';
                            $scope.data[arrProperty].push(result[i]);
                        }
                    }
                });
            };

            /**
             * [getSuggestions description]获取suggestion
             * @param  {[str]} viewValue [description]输入框内输入值
             * @return {[type]}           [description]
             */
            $scope.getSuggestions = function(property, viewValue) {
                var searchUsers = {
                    serviceid: 'mlf_extuser',
                    methodname: 'queryUsersByName',
                    IsSearchAll: false,
                    Name: viewValue
                };
                if (viewValue !== '' && !angular.isObject(viewValue)) {
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, 'post').then(function(data) {
                        if (data.length === 1 && data[0].USERNAME === $scope.data[property].USERNAME) {
                            data = [];
                        }
                        return data;
                    });
                }
            };

            /**
             * [functio description] 保存
             * @return {[type]} [description]
             */
            $scope.save = function(type) {
                type = angular.isDefined(type) ? type : true;
                var defer = $q.defer();
                save(type).then(function() {
                    if (type === true) {
                        editIsLock.lockDraft($stateParams.broadcastmetadataid);
                    }
                    getVersion($scope.list.METADATAID).then(function() {
                        defer.resolve();
                    });
                });
                return defer.promise;
            };

            /**
             * [trial description] 送审
             * @return {[type]} [description]
             */
            $scope.trial = function() {
                $scope.save(false).then(function() {
                    trial();
                });
            };

            /**
             * [directSign description] 直接签发
             * @return {[type]} [description]
             */
            $scope.directSign = function() {
                $scope.save(false).then(function() {
                    directSign();
                });
            };
            // 传稿函数结束
            /**
             * [close description]页面关闭
             * @return {[type]} [description]
             */
            $scope.close = function() {
                editingCenterService.closeWinow($scope.manuscriptForm.$dirty, ueditorService.contentTranscoding($scope.list) != ueditorService.bindContent()).then(function() {
                    editIsLock.normalLock($stateParams.broadcastmetadataid).then(function(data) {
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    });
                }, function() {
                    editIsLock.normalLock($stateParams.broadcastmetadataid).then(function(data) {
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    });
                });
            };

            /**
             * [withdraw description] 退回
             * @return {[type]} [description]
             */
            $scope.withdraw = function() {
                $scope.save(false).then(function() {
                    withdraw();
                });
            };

            /**
             * [retreat description] 退稿
             * @return {[type]} [description]
             */
            $scope.retreat = function() {
                $scope.save(false).then(function() {
                    retreat();
                });
            };

            /**
             * [description] 保存并发布
             * @return {[type]} [description]
             */
            $scope.publish = function() {
                $scope.save(false).then(function() {
                    publish();
                });
            };
        }
    ]);
